function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M62.5 95.8946C97.0178 95.8946 125 89.347 125 81.27C125 73.1931 97.0178 66.6455 62.5 66.6455C27.9822 66.6455 0 73.1931 0 81.27C0 89.347 27.9822 95.8946 62.5 95.8946Z",
  fill: "#DADADA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.4854 27.6494L15.001 40.6005L70.1572 47.4399L91.751 33.1849L41.4854 27.6494Z",
  fill: "#2C4756"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.001 40.5996V76.2515L69.376 87.1654L70.1572 47.2934L15.001 40.5996Z",
  fill: "#5A6D78"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M91.5635 66.2114L69.376 87.166L70.1572 47.4395L91.751 33.1846L91.5635 66.2114Z",
  fill: "#7B8D97"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M109.064 45.5478L91.752 33.1846L70.1582 47.4395L86.0957 62.8644L109.064 45.5478Z",
  fill: "#9BA5AA"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M80.9385 40.3085C78.5947 27.9394 70.9385 24.7381 72.1885 14.1152C72.4525 11.8699 74.0635 6.98486 72.8135 2.32829C67.1885 9.31315 51.0947 8.73108 44.2197 0C41.5635 6.25727 42.6572 8.73108 43.5947 12.8056C46.0572 23.5084 37.1885 26.7753 34.2197 42.9278L70.1572 47.4389L80.9385 40.3085Z",
  fill: "#D9D4CC"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M53.5744 16.7721C54.3625 16.7721 55.0013 16.1771 55.0013 15.4432C55.0013 14.7092 54.3625 14.1143 53.5744 14.1143C52.7863 14.1143 52.1475 14.7092 52.1475 15.4432C52.1475 16.1771 52.7863 16.7721 53.5744 16.7721Z",
  fill: "#2C4756"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.625 18.3351C56.875 18.095 58.1719 18.0674 59.5312 18.3351C59.0625 20.9544 55.7812 20.3724 55.625 18.3351Z",
  fill: "#2C4756"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M61.1235 18.6953L68.2968 17.7174C68.3609 17.7102 68.4078 17.6549 68.3984 17.5937C68.3906 17.5341 68.3313 17.4904 68.2657 17.4992L61.064 18.2675C60.9374 18.2835 60.8485 18.3912 60.8641 18.509C60.8813 18.6269 60.9969 18.7099 61.1235 18.6953Z",
  fill: "#9BA5AA"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M61.0803 19.3486L69.9916 19.7454C70.0571 19.7497 70.114 19.7023 70.1191 19.6397C70.1227 19.577 70.0736 19.523 70.008 19.5201L61.1121 18.9071C60.9841 18.9001 60.8737 18.9923 60.8652 19.1147C60.857 19.2355 60.9525 19.3402 61.0803 19.3486Z",
  fill: "#9BA5AA"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M60.7139 20.0075L67.612 21.9334C67.6742 21.9529 67.7416 21.9196 67.7619 21.8594C67.7821 21.7992 67.7485 21.7353 67.6874 21.7176L60.8588 19.5853C60.737 19.5483 60.6055 19.6144 60.5663 19.7304C60.5267 19.8479 60.5917 19.9719 60.7139 20.0075Z",
  fill: "#9BA5AA"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M54.1001 18.3398L46.8984 17.5714C46.8328 17.5627 46.7735 17.6063 46.7656 17.666C46.7563 17.7271 46.8032 17.7824 46.8673 17.7897L54.0406 18.7676C54.1671 18.7821 54.2828 18.6992 54.3 18.5813C54.3156 18.4634 54.2267 18.3558 54.1001 18.3398Z",
  fill: "#9BA5AA"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M54.0569 18.9794L45.161 19.5932C45.0954 19.5961 45.0463 19.65 45.0499 19.7127C45.0551 19.7753 45.112 19.8228 45.1774 19.8184L54.0887 19.4209C54.2165 19.4124 54.3121 19.3078 54.3038 19.1869C54.2953 19.0646 54.1848 18.9724 54.0569 18.9794Z",
  fill: "#9BA5AA"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M54.2984 19.6566L47.4697 21.7885C47.4086 21.8062 47.375 21.8701 47.3952 21.9303C47.4155 21.9905 47.4829 22.0238 47.5451 22.0043L54.4433 20.0787C54.5655 20.0432 54.6306 19.9192 54.5909 19.8017C54.5517 19.6856 54.4203 19.6196 54.2984 19.6566Z",
  fill: "#9BA5AA"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M61.5832 16.7721C62.3713 16.7721 63.0101 16.1771 63.0101 15.4432C63.0101 14.7092 62.3713 14.1143 61.5832 14.1143C60.7951 14.1143 60.1562 14.7092 60.1562 15.4432C60.1562 16.1771 60.7951 16.7721 61.5832 16.7721Z",
  fill: "#2C4756"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M57.3474 20.1035C57.4036 20.6099 57.2224 21.1629 56.7864 21.5645C56.4208 21.9021 55.8802 22.1335 55.1568 22.1539C55.0912 22.1539 55.0381 22.2034 55.0381 22.2645C55.0381 22.3256 55.0912 22.3751 55.1568 22.3751C55.9709 22.3969 56.5896 22.1612 57.0271 21.8047C57.5849 21.3477 57.8381 20.6871 57.81 20.073C57.8006 19.9551 57.6896 19.8649 57.5614 19.8736C57.4349 19.8824 57.3395 19.9857 57.3474 20.1035Z",
  fill: "#2C4756"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M57.4253 20.073C57.3972 20.6871 57.6505 21.3477 58.2083 21.8047C58.6458 22.1612 59.2645 22.3969 60.0786 22.3751C60.1442 22.3751 60.1973 22.3256 60.1973 22.2645C60.1973 22.2034 60.1442 22.1539 60.0786 22.1539C59.3551 22.1335 58.8145 21.9021 58.4489 21.5645C58.013 21.1629 57.8317 20.6099 57.888 20.1035C57.8958 19.9857 57.8005 19.8824 57.6739 19.8736C57.5458 19.8649 57.4347 19.9551 57.4253 20.073Z",
  fill: "#2C4756"
});

var SvgImage = function SvgImage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 96,
    viewBox: "0 0 125 96",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/image.d3cd1641.svg";
export { ForwardRef as ReactComponent };